import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../components/layout/layout"
import PrimaryBanner from "../../components/banner/primaryBanner"
import LXPCard from "../../components/card/LXPCard"
import TrainingPartnersCard from "../../components/card/TrainingPartnersCard"

import Button from "../../components/button/button"

import "../../styles/_trainingPartners.scss"

import teamsPlusLogo from "../../images/teamsplus-logo.svg"
import learnPlusLogo from "../../images/learnplus-logo.svg"
import LearnPlusManager from "../../images/learnplus-manager.png"

import quoteIcon from "../../images/icon/quote.svg"
import newWindowIcon from "../../images/icon/new-window.svg"
import newWindowDarkIcon from "../../images/icon/new-window-dark.svg"

import { trainingPartnerData } from "../../pageData/trainingPartners"
import CustomLink from "../../components/naviGroup/customLink"

interface TrainingPartnerProps {
  logo: string
  name: string
  brief: string
  webLink?: string
}

const TrainingPartner: React.FC<TrainingPartnerProps> = ({
  logo,
  name,
  brief,
  webLink,
}) => {
  const altText = name + " logo"
  return (
    <div className="partner-wrapper">
      <div className="wrapper-header">
        <div className="wrapper-title">{name}</div>
        <div className="partnerLogo">
          <img src={logo} alt={altText} />
        </div>
      </div>

      <div className="wrapper-body">
        <div className="brief">
          <p>{brief}</p>
        </div>

        {webLink && (
          <CustomLink to={webLink}>
            <button className="btn-sm btn-prim center">
              <div>Visit</div>
              <img
                src={newWindowIcon}
                alt="link"
                style={{ width: "20px", marginLeft: "15px" }}
              />
            </button>
          </CustomLink>
        )}
      </div>
    </div>
  )
}

const Brief: React.FC = () => {
  return (
    <div className="brief-container layout-container">
      <div className="brief-left">
        <h1>
          <span>Training </span>
          <span>Partners</span>
        </h1>
        <div className="solution-with-container">
          <span className="solution-with-label">benefitting with</span>
          <img src={teamsPlusLogo} alt="learn plus logo" />
        </div>
        <p className="p-lg" style={{ marginBottom: "35px" }}>
          Dacreed has partnered with industry-leading training organisations to
          bring you the best training content for financial advisers in New
          Zealand. All of the content comes rated with CPD hours and can be used
          as part of your ongoing professional development plan. To see more,
          click on the link for each training partner
        </p>
        <CustomLink to="http://www.teamsplus.co.nz">
          <Button isResponsive={true}>
            Learn more at TeamsPlus.co.nz
            <img
              alt="go to TeamsPlus.co.nz"
              src={newWindowIcon}
              style={{ width: "20px", marginLeft: "15px" }}
            />
          </Button>
        </CustomLink>
      </div>
      <div className="brief-right">
        <div className="brief-right-background learnplus-right"></div>
        <div className="brief-right-image trainingPartners-right"></div>
      </div>
    </div>
  )
}

const TrainingPartnersSection: React.FC = () => {
  return (
    <div className="trainingPartners-group-wrapper">
      <div className="layout-container">
        {trainingPartnerData.map((partner) => (
          <TrainingPartner
            key={partner.name}
            name={partner.name}
            logo={partner.logo}
            brief={partner.brief}
            webLink={partner.webLink}
          />
        ))}
      </div>
    </div>
  )
}

const ReviewSection: React.FC = () => {
  const ReviewCard: React.FC = () => {
    return (
      <div className="review-card-container">
        <div className="review-card-quote">
          <img src={quoteIcon} alt="quote icon" />
        </div>
        <p className="p-lg">
          We are an innovative training provider offering learning virtually
          anywhere.
        </p>
        <div className="review-owner-wrapper">
          <div className="review-owner-container">
            <img
              src={LearnPlusManager}
              className="review-owner-image"
              alt="Learn plus manager"
            />
            <div>
              <div style={{ fontWeight: "700" }}>Geordie Wilson</div>
              <div>General Manager</div>
            </div>
          </div>
          <img src={learnPlusLogo} alt="LearnPlus Logo" />
        </div>
      </div>
    )
  }

  return (
    <PrimaryBanner>
      <div className="layout-container">
        <div className="review-section-container">
          <ReviewCard></ReviewCard>
          <h4 className="review-heading">Choose the better way of learning</h4>
          <CustomLink to="http://www.learnplus.ac.nz">
            <Button isSecondary={true} isSmall={true}>
              Learn more at learnplus.ac.nz
              <img
                alt="go to learnplus.ac.nz"
                src={newWindowDarkIcon}
                style={{ width: "20px", marginLeft: "15px" }}
              />
            </Button>
          </CustomLink>
        </div>
      </div>
    </PrimaryBanner>
  )
}

const OtherSolutionSection: React.FC = () => {
  return (
    <div className="layout-container other-solution-section-container">
      <h2>Explore other solutions</h2>
      <div className="other-solution-card-group">
        <TrainingPartnersCard className="other-solution-card" />
        <LXPCard className="other-solution-card" />
      </div>
    </div>
  )
}

const LearnPlus: React.FC = () => {
  return (
    <Layout>
      <Helmet>
        <title>Dacreed Training Partners</title>
        <meta
          name="description"
          content="LearnPlus - Flexible Learning Pathways to Accredited Qualifications"
        />
      </Helmet>
      <div className="trainingPartners">
        <Brief />
        <TrainingPartnersSection />
        <ReviewSection />
      </div>
      <OtherSolutionSection />
    </Layout>
  )
}

export default LearnPlus
